import React, {Component} from 'react'
import {authenticationService} from '../../../services/AuthenticationService';

import SvGraphics from "../../../assets/SvGraphics";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import utils from "../../../utils/utils";
import Error from "../../../components/single_components/Error";
import Config from "../../../config/Config";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

class CreatePasswordComposed extends Component {
    constructor(props) {
        super(props);

        if (!authenticationService.pwdUserValue) {
            this.props.history.push('/');
        }

        this.state = {
            password1: '',
            passwordConfirm: '',
            auth: {},
            isErr: false,
            errMessage: '',
            errors: {},
            errorsOnSave: {},
        }
    }

    initValidation = async () => {
        let {t} = this.props

        let validationSchema = Yup.object().shape({
            password1: Yup.string().matches(Config.passwordRegExp, t('defaults.crt_pwd.pwd_validation')).required(t('defaults.crt_pwd.pwd_req')),
            passwordConfirm: Yup.string().oneOf([Yup.ref('password1'), null], t('defaults.crt_pwd.pwd_match')).test('match', t('defaults.crt_pwd.pwd_match'), function (password1) {
                return password1 === this.parent.passwordConfirm
            }).required(t('defaults.crt_pwd.pwd_confirm_req'))
        })
        let errors = await validationHelper.validate(this.state.auth, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    async componentWillMount() {
        await this.initValidation()
    }

    onSubmit = async () => {
        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            return;
        }
        let {password1} = this.state
        let response = await authenticationService.changeNewPassword(password1, true);
        if (response.status < 400) {
            let data = response.data
            if (data && data.hasOwnProperty('newPassword') && data['newPassword'] === true) {
                let path = "/dashboard"
                if (data.role[0] === "Patient") {
                    path = "/PatientSelfOnBoard";
                }

                const {from} = {from: {pathname: path}};

                this.props.history.push(from);
            } else {
                await this.setPassword1({target: {value: '', name: 'password1'}})
                await this.setpasswordConfirm({target: {value: '', name: 'passwordConfirm'}})
                this.setState({
                    password1: '',
                    passwordConfirm: '',
                    isErr: true,
                    errMessage: response.data ? response.data.message : 'No connection to server',
                })
            }
        } else {
            this.setState({
                password1: '',
                passwordConfirm: '',
                isErr: true,
                errMessage: response.data ? response.data.message : 'No connection to server',
            })
        }
    }

    setPassword1 = async (e) => {
        let {auth, validationSchema} = this.state
        let name = 'password1'
        this.setState({password1: e.target.value.trim()})
        utils.set(auth, name, e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false,
            errMessage: ''
        })
    }

    setPasswordConfirm = async (e) => {
        let {auth, validationSchema} = this.state
        let name = 'passwordConfirm'
        this.setState({passwordConfirm: e.target.value.trim()})
        utils.set(auth, name, e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false,
            errMessage: ''
        })
    }

    render() {
        let {t} = this.props
        return (
            <div className={"login-page"}>
                <div className={'sade-login-logo-container'}>
                    <SvGraphics svgname={'asaya_logo'} className={'sade-asaya-login-logo'}/>
                </div>
                <div className={'sade-login-main-board'}>
                    <div className={'create-password-label-svg'}>

                        <label className={'sade-login-label-create-Leumit'}>{t('defaults.crt_pwd.new_pwd_info')}</label>
                    </div>
                    <div className={'sade-login-form-container-reg'}>
                        <div className={'sade-Pain-login-form'}>
                            <div>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.crt_pwd.pwd')}
                                           type={"password"}
                                           name={"password1"}
                                           value={this.state.password1}
                                           onChange={e => this.setPassword1(e)}
                                           onKeyPress={event => {
                                               if (event.key === 'Enter') {
                                                   this.onSubmit()
                                               }
                                           }}/>
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'password1') ? "input-pic2" : "input-pic"}
                                        svgname={'lock'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'password1')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'password1')}/>
                            </div>

                            <div>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.crt_pwd.pwd_valid_lbl')}
                                           type={"password"}
                                           name={"passwordConfirm"}
                                           value={this.state.passwordConfirm}
                                           onChange={e => this.setPasswordConfirm(e)}
                                           onKeyPress={event => {
                                               if (event.key === 'Enter') {
                                                   this.onSubmit()
                                               }
                                           }}/>
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'password1') ? "input-pic2" : "input-pic"}
                                        svgname={'lock'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'passwordConfirm')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'passwordConfirm')}/>

                            </div>

                            <div className="form-group sade-login-form-group">
                                <button className="btn h-centered btn-primary sade-login-form-button"
                                        onClick={this.onSubmit}>{t('defaults.crt_pwd.submit')}</button>
                            </div>

                        </div>
                    </div>
                    <div className={'sade-login-form-group loginError red h-centered'}>
                        <Error isNonFloat={true}
                               errorMessage={t('defaults.crt_pwd.auth_err') + ': ' + this.state.errMessage}
                               isShown={this.state.isErr}/>
                    </div>

                </div>


                <div className={'login-version-element'}>
                        <div className={'login-version-element-label'}>Version:</div>
                        <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                    </div>
            </div>

        )
    }
}

let CreatePassword = compose(
    withTranslation()
)(CreatePasswordComposed)

export default CreatePassword;
